import * as List from './tornei-list.actions';
import * as Detail from './tornei-detail.actions';

export const TorneiActions = {
  List,
  Detail
};
